import { render, staticRenderFns } from "./ItemCategory.vue?vue&type=template&id=f217bada&scoped=true&"
import script from "./ItemCategory.vue?vue&type=script&lang=js&"
export * from "./ItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f217bada",
  null
  
)

export default component.exports